import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
})
export class TermsAndConditionsComponent {
  constructor(private router: Router) {}

  back(): void {
    this.router.navigate(['/customer/customer-orders']);
  }
}
